import React, { useEffect, useState } from 'react';
import { ClassGroupType } from '../../../../constants/types/student-type';
import { LmsClassGroupType } from '../../../../constants/types/lms-type';
import { getClassGroupList } from '../../../../api/utils/lms/class-group/api';
import { Radio, Skeleton } from 'antd';
import { useNavigate } from 'react-router-dom';
import { ArrowRightIcon } from '@heroicons/react/24/outline';
import HFbutton from '../../../button/HFbutton';
import TextWinds from '../../../common/TextWinds';
import { useAppDispatch } from '../../../../store/hook';
import { closeModal } from '../../../../store/features/modalSlice';

interface ClassGroupList {
  classId: string;
  selected: ClassGroupType | undefined;
  setSelected: React.Dispatch<React.SetStateAction<ClassGroupType | undefined>>;
}

const ClassGroupList = ({ classId, selected, setSelected }: ClassGroupList) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [classList, setClassList] = useState<LmsClassGroupType[]>();
  const [selectRadio, setSelectRadio] = useState<number>(selected?.id);

  useEffect(() => {
    getClassGroupList(classId, { isActive: true }).then((res) => {
      setClassList(res.result);
    });
  }, []);

  const radioHandler = (e: any) => {
    const value = e.target.value;
    setSelectRadio(value);
    setSelected(classList?.find((item) => item.id === value));
  };

  return classList ? (
    <div className="flex h-[180px] w-full overflow-y-auto">
      {classList.length > 0 ? (
        <Radio.Group
          onChange={radioHandler}
          value={selectRadio}
          className="flex w-full flex-col gap-1"
        >
          {classList.map((classItem) => (
            <Radio
              key={classItem.id}
              value={classItem.id}
              className={`w-full items-start rounded p-1 px-3 ${
                classItem.id === selectRadio ? 'bg-purple1' : 'bg-gray1'
              } hover:bg-purple2`}
            >
              <span className="flex flex-col">
                <TextWinds type="content_body3" color="gray9">
                  {classItem.name}
                </TextWinds>
                {classItem.description && (
                  <TextWinds
                    type="content_body4"
                    color="gray7"
                    className="whitespace-pre-wrap break-words"
                  >
                    {classItem.description}
                  </TextWinds>
                )}
              </span>
            </Radio>
          ))}
        </Radio.Group>
      ) : (
        <div className="flex h-full w-full flex-col items-center justify-center gap-2 rounded bg-gray1 p-4">
          <TextWinds type="content_body3" color="gray7">
            활성화된 반이 없습니다.
          </TextWinds>
          {/* 배정하려면 먼저 반을 만들어야 하므로 반 관리로 바로 갈 수 있게 한다. */}
          <HFbutton
            type="primary-outlined"
            width="auto"
            height={38}
            onClick={() => {
              dispatch(closeModal());
              navigate(`/lms/${classId}/class-group`);
            }}
          >
            <span className="flex items-center gap-1">
              반 만들러 가기
              <ArrowRightIcon className="h-4 w-4" />
            </span>
          </HFbutton>
        </div>
      )}
    </div>
  ) : (
    <Skeleton />
  );
};

export default ClassGroupList;
